import { GovernmentBusinessDashboardModel } from 'src/app/models/model'
import { GovernmentBusinessAPIModel, PaginatedAPI } from '../../models/api.model'

export interface GovernmentBusinessState {
  dashboard: GovernmentBusinessDashboardModel
  details: GovernmentBusinessAPIModel
  summary: PaginatedAPI<GovernmentBusinessAPIModel>
}

export const initialGovernmentState: GovernmentBusinessState = {
  dashboard: undefined,
  details: undefined,
  summary: undefined
}
